import { useCallback, useEffect, useState } from 'react';
import { PROFILE_STORES_APPOINTMENTS_CATALOG_SERVICES } from '../../../shared/constants/endpoints';

// Loads the flat list of every service in the store's service menu so offer
// targeting can pick individual services from the live catalog.
const useServiceCatalog = ({ request, storeToken, onToast, enabled = true } = {}) => {
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  const fetchCatalog = useCallback(async () => {
    if (typeof request !== 'function' || !storeToken) {
      setServices([]);
      setHasLoaded(true);
      return;
    }
    setIsLoading(true);
    try {
      const response = await request(PROFILE_STORES_APPOINTMENTS_CATALOG_SERVICES, {
        method: 'GET',
        requestName: 'offers-services-catalog'
      });
      const payload = response?.data;
      setServices(Array.isArray(payload) ? payload : []);
    } catch (error) {
      setServices([]);
      onToast?.({ message: 'Unable to load your service menu.', variant: 'error' });
    } finally {
      setIsLoading(false);
      setHasLoaded(true);
    }
  }, [request, storeToken, onToast]);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    fetchCatalog();
  }, [enabled, fetchCatalog]);

  return { services, isLoading, hasLoaded, refetchCatalog: fetchCatalog };
};

export default useServiceCatalog;
